import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon } from "lucide-react";
import { Reveal } from "../Reveal";
import { collections } from "../../data/collections";
import { products } from "../../data/products";
import { images } from "../../data/store";
import type { CollectionSlug } from "../../types/product";
const layout: Record<CollectionSlug, {
  className: string;
  lifestyle?: string;
}> = {
  "royal-honey": {
    className: "lg:col-span-2 lg:row-span-2 min-h-[360px]",
    lifestyle: images.honey
  },
  "seven-sins": {
    className: "lg:col-span-2 min-h-[260px]",
    lifestyle: images.couple
  },
  "devils-candy": {
    className: "min-h-[260px]"
  },
  "high-octane": {
    className: "min-h-[260px]"
  }
};
export function CollectionRail() {
  return <section className="bg-night py-20 lg:py-28" aria-labelledby="collections-title" data-id="element-176" data-mp="lhoy9sb9v9wr">
      <div className="mx-auto max-w-7xl px-6" data-id="element-177" data-mp="1i2yzibdkulf7">
        <Reveal className="flex flex-wrap items-end justify-between gap-4" data-id="element-178" data-mp="1dafnhiujfyci">
          <h2 id="collections-title" className="font-display text-4xl font-extrabold tracking-tight sm:text-5xl" data-id="element-179" data-mp="vbvaflxxjy36">
            Find your <span className="text-outline" data-id="element-180" data-mp="10bhmvt5xpaax">sin.</span>
          </h2>
          <p className="max-w-sm text-muted" data-id="element-181" data-mp="10cspvqrk2e0z">Four collections, one goal — more pleasure, passion and performance.</p>
        </Reveal>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:grid-rows-[260px_260px]" data-id="element-182" data-mp="qkd92wrzvvho">
          {collections.map((c, i) => {
          const count = products.filter(p => p.collection === c.slug).length;
          const {
            className,
            lifestyle
          } = layout[c.slug];
          return <Reveal key={c.slug} delay={i * 0.05} className={`flex ${className}`} data-id="element-183" data-mp="2nzcyf0je25c" data-mpi={i}>
                <Link to={`/shop?collection=${c.slug}`} className={`group relative isolate flex w-full flex-col justify-end overflow-hidden rounded-3xl p-6 ${lifestyle ? "bg-raised" : "bg-white"}`} data-id="element-184" data-mp="7lr7zhwha4dr">
                  <img src={lifestyle ?? c.image} alt="" className={`absolute inset-0 -z-10 h-full w-full transition-transform duration-300 ease-brand group-hover:scale-[1.05] ${lifestyle ? "object-cover" : "object-contain p-6 pb-24"}`} data-id="element-185" data-mp="20jo38td7bjdf" />
                  {lifestyle && <div className="absolute inset-0 -z-10 bg-night/40" aria-hidden="true" data-id="element-186" data-mp="1mlq3ou3jhrhz" />}
                  <div className="flex items-end justify-between gap-4 rounded-2xl bg-night/85 p-4 backdrop-blur-md" data-id="element-187" data-mp="2jbqqwoo9fzx6">
                    <div data-id="element-188" data-mp="29jt7wvr0g3nw">
                      <p className="font-display text-xl font-bold" data-id="element-189" data-mp="29j1e9qgz4g09">{c.name}</p>
                      <p className="mt-0.5 text-sm text-muted" data-id="element-190" data-mp="25ihlez3fnyjx">
                        {c.description} · {count}
                      </p>
                    </div>
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-night transition-[background-color,transform] duration-200 ease-brand group-hover:rotate-45 group-hover:bg-brand" data-id="element-191" data-mp="3228fqi5z2bd9">
                      <ArrowUpRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-192" data-mp="opko3zawsjn7" />
                    </span>
                  </div>
                </Link>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}